import types from './types';

const setConfig = (config) => ({
  type: types.SET_CONFIG,
  payload: {
    config
  }
});

const setOriginFieldInfos = (fieldInfos) => ({
  type: types.SET_ORIGIN_FIELD_INFOS,
  payload: {
    fieldInfos
  }
});

const setPerimeterFieldInfos = (fieldInfos) => ({
  type: types.SET_PERIMETER_FIELD_INFOS,
  payload: {
    fieldInfos
  }
});

const setSortField = (sortField) => ({
  type: types.SET_SORT_FIELD,
  payload: {
    sortField
  }
});

const setSortDesc = (sortDesc) => ({
  type: types.SET_SORT_DESC,
  payload: {
    sortDesc
  }
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setConfig,
  setOriginFieldInfos,
  setPerimeterFieldInfos,
  setSortField,
  setSortDesc
};
